import { render, staticRenderFns } from "./KidsClubFamilyInfo.vue?vue&type=template&id=23b8e3fb&"
import script from "./KidsClubFamilyInfo.vue?vue&type=script&lang=js&"
export * from "./KidsClubFamilyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports